import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fiscalDate',
    standalone: false
})
export class FiscalDatePipe implements PipeTransform {

  transform(value: number, ...args: unknown[]): Date {
    if(typeof value !== 'number') {
      return value;
    }

    // Value is days since epoch. We'll change it to millis since epoch and return the date
    return new Date(1970, 0, 1 + value);
  }

}
